module.exports = __webpack_public_path__ + "img/red-flag.c69a4392.png";